var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_7363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0395 4.69521C17.419 5.0471 17.419 5.61611 17.0395 5.93431L7.21809 15.8171C6.90187 16.199 6.33639 16.199 5.98669 15.8171L0.928244 10.726C0.579583 10.4078 0.579583 9.83877 0.928244 9.48688C1.27687 9.13874 1.84234 9.13874 2.19093 9.48688L6.61913 13.9454L15.8081 4.69521C16.1578 4.34557 16.7233 4.34557 17.0395 4.69521Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_7363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 19.1667,
    fill: "currentColor",
    transform: "translate(0.666748 0.839478)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRegular);
export default __webpack_public_path__ + "static/media/check-regular.6b3496b886aaf8420f6a700d2107ea0c.svg";
export { ForwardRef as ReactComponent };